import { useEphattaQuery } from "../../.."
import { useCustomerService } from "./useCustomerService"

export const useCustomerNationalities = () => {
    const service = useCustomerService()
    return useEphattaQuery("Customer.Nationalities", () => service.getNationalities())
} 